import styled, { css } from 'styled-components'
import Button from 'components/common/Button/Button'
import Text from 'components/common/Text/Text'
import Columns from 'components/common/Columns/Columns'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'

export const Schedule = styled.div`
  ${Mixin.responsive('padding', '5px 0 5px 24px', '40px 0 0')}
  ${props => props.oneColumn && css`
    padding: 0;
    ${Media.mobile`
      overflow-y: visible;
    `}
  `}
`

export const Description = styled(Text)`
  ${props => props.leftAlign && css`
    text-align: left;
  `}
  padding: ${props => props.padding || '0'};
  margin: ${props => props.margin || '16px 0 10px'};
  width: ${props => props.width || 'auto'};
`

export const Message = styled.div`
  text-align: center;
  margin-bottom: 24px;
  ${Media.mobile`
    margin-top: 20px;
    ${props => props.leftAlign && css`
      text-align: left;
      margin: 20px 0 10px 0;
    `}
  `}
  ${props => props.mobileOnly && css`
    ${Media.desktop`
      display: none;
    `}
  `}
`

export const MyColumns = styled(Columns)`
  ${props => props.special && css`
    & [data-column]:last-child {
      vertical-align: middle;
      text-align: center;
    }
  `}
`

export const CustomColumns = styled(Columns)`
  & [data-column] {
    ${Mixin.responsive('padding', '0 5px', '0 8px')}
  }
`

export const Drop = styled(Button)`
  width: 100%;
  text-align: center;

  && {
    padding: 5px 0 0;
  }
`

export const Times = styled.div`
  ${Mixin.responsive('margin', '15px -5px -4px', '13px -8px 2px')}
  ${props => props.oneColumn && css`
    margin: 0 0 0 25px;
    overflow-y: auto;
    max-height: 435px;

    & > fieldset > div {
      max-width: 252px;
      margin: 0 auto 10px;
    }
  `}
`

export const NextDayContainer = styled.div`
  ${Media.desktop`
    max-height: 100px;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-right: 10px;
    ${props => props.showOverflow && css`
      overflow-y: hidden;
    `}
  `}
`

export const NextDayCount = styled(Text)`
  color: ${Theme.colors.red};
`

export const Separator = styled.div`
  margin: 20px auto;
  position: relative;
  outline: 0;
  border: 0;
  color: ${Theme.colors.black};
  text-align: center;
  ${Mixin.responsive('width', '200px', '125px')}

  &::before {
    content: '';
    background: black;
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }

  &::after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    padding: 0 10px;
    text-transform: uppercase;
    color: ${Theme.colors.black};
    background-color: ${Theme.colors.white};
  }
`
